export * from './static-string-select.component';
